import '../../styles/blog.scss';
import BlogNavigation from '../ui/blog-navigation';

new BlogNavigation('[data-blog-nav]');
